"use client";

import { useEffect, useState } from "react";

const STORAGE_KEY = "ftr-onboarded-v1";

export default function OnboardingModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!localStorage.getItem(STORAGE_KEY)) {
      setOpen(true);
    }
  }, []);

  function dismiss() {
    try {
      localStorage.setItem(STORAGE_KEY, "1");
    } catch {
      // ignore — private mode etc.
    }
    setOpen(false);
  }

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-4"
      style={{ background: "rgba(0,0,0,0.65)" }}
      onClick={dismiss}
    >
      <div
        className="w-full max-w-md rounded-2xl pop-in"
        style={{
          background: "var(--surface)",
          border: "1px solid var(--border)",
          padding: "24px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-bold mb-1">
          Welcome to <span style={{ color: "var(--accent)" }}>FTR</span>
        </h2>
        <p className="text-sm text-[var(--muted)] mb-5">
          Quick heads-up before you queue:
        </p>

        <ol className="space-y-4 mb-6">
          <li className="flex gap-3">
            <span
              className="shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold"
              style={{ background: "var(--accent)", color: "var(--background)" }}
            >
              1
            </span>
            <div>
              <p className="font-semibold text-sm">Type a song, tap to queue</p>
              <p className="text-sm text-[var(--muted)] mt-0.5">
                Search the bar below and tap the result you want. That&apos;s it — no login.
              </p>
            </div>
          </li>

          <li className="flex gap-3">
            <span
              className="shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold"
              style={{ background: "var(--accent)", color: "var(--background)" }}
            >
              2
            </span>
            <div>
              <p className="font-semibold text-sm">Be patient — 5 to 10 minutes</p>
              <p className="text-sm text-[var(--muted)] mt-0.5">
                Spotify rate-limits us. Your song is queued, but it may not show in the
                list right away. <span className="font-semibold">Don&apos;t re-queue it</span> —
                you&apos;ll get blocked from spamming.
              </p>
            </div>
          </li>

          <li className="flex gap-3">
            <span
              className="shrink-0 w-7 h-7 rounded-full flex items-center justify-center text-sm font-bold"
              style={{ background: "var(--accent)", color: "var(--background)" }}
            >
              3
            </span>
            <div>
              <p className="font-semibold text-sm">Keep it bar-appropriate</p>
              <p className="text-sm text-[var(--muted)] mt-0.5">
                The host can remove any track and block the user behind it. Auto-rejects
                are real. Play nice.
              </p>
            </div>
          </li>
        </ol>

        <button
          onClick={dismiss}
          className="w-full py-3 rounded-xl font-semibold min-h-[44px]"
          style={{ background: "var(--accent)", color: "var(--background)" }}
        >
          Got it — don&apos;t show this again
        </button>
      </div>
    </div>
  );
}
